import React from 'react';
import { FileAudio, Link as LinkIcon } from 'lucide-react';

type FilType = 'upload' | 'url';

export const getFilTypeIcon = (type: FilType): React.ReactNode => {
  switch (type) {
    case 'upload':
      return <FileAudio className="h-4 w-4" />;
    case 'url':
      return <LinkIcon className="h-4 w-4" />;
  }
};

export const getFilTypeLabel = (type: FilType): string => {
  switch (type) {
    case 'upload':
      return 'Opplastet fil';
    case 'url':
      return 'URL';
  }
};

export const getFilTypeColor = (type: FilType): string => {
  switch (type) {
    case 'upload':
      return 'bg-blue-100 text-blue-700 border-blue-200';
    case 'url':
      return 'bg-purple-100 text-purple-700 border-purple-200';
  }
};

export const formatFileSize = (bytes?: number): string => {
  if (!bytes) return '';
  const mb = bytes / 1024 / 1024;
  return `${mb.toFixed(2)} MB`;
};

